import { useEffect, useState } from "react";
import { Trophy, ChevronDown, ChevronUp } from "lucide-react";
import { adminApi } from "@/lib/api";
import { fmtDate, money } from "./shared";

const KEY = "aurora_chf_eur";
const clean = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v));

const RateInput = ({ rate, setRate }) => (
  <label className="flex items-center gap-2 text-[10px] uppercase font-mono text-[#6b7280]">
    Cambio ordinamento: 1 CHF =
    <input data-testid="top-rate-input" type="number" step="0.01" min="0.01" max="10" value={rate}
      onChange={(e) => setRate(e.target.value)}
      className="w-20 h-8 bg-[#f4f6f7] border border-[#d5dbde] text-[#2B3036] text-xs font-mono px-2 outline-none focus:border-[#E0262C]" /> EUR
  </label>
);

const Row = ({ c }) => (
  <tr data-testid={`top-row-${c.rank}`} className="border-t border-[#d5dbde] hover:bg-[#f4f6f7]">
    <td className={`px-4 py-3 font-display text-xl ${c.rank <= 3 ? "aurora-text" : "text-[#6b7280]"}`}>{c.rank}</td>
    <td className="px-4 py-3"><div className="font-medium">{c.company || c.name || "—"}</div>
      <div className="font-mono text-xs text-[#6b7280]">{c.company && c.name ? `${c.name} · ` : ""}{c.email}</div></td>
    <td className="px-4 py-3 font-mono">{c.count}</td>
    <td className="px-4 py-3 font-display">{c.eur ? money(c.eur, "eur") : "—"}</td>
    <td className="px-4 py-3 font-display">{c.chf ? money(c.chf, "chf") : "—"}</td>
    <td className="px-4 py-3 font-mono text-xs text-[#5b6168]">{fmtDate(c.last_at)}</td>
  </tr>
);

export const TopClients = ({ filters }) => {
  const [rate, setRate] = useState(() => localStorage.getItem(KEY) || "1.05");
  const [rows, setRows] = useState([]);
  const [all, setAll] = useState(false);
  useEffect(() => {
    const r = Number(rate);
    if (!(r > 0 && r <= 10)) return;
    localStorage.setItem(KEY, rate);
    const t = setTimeout(() => adminApi.topClients({ ...clean(filters), chf_eur: r }).then((d) => setRows(d.clients)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [filters, rate]);
  const shown = all ? rows : rows.slice(0, 10);
  return (
    <div data-testid="inv-top-clients" className="border border-[#d5dbde]">
      <div className="px-4 py-3 bg-[#f4f6f7] flex flex-wrap items-center gap-3 justify-between">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest font-mono text-[#6b7280]">
          <Trophy className="w-3.5 h-3.5 text-[#E0262C]" /> Clienti migliori · {rows.length} clienti nel periodo
        </div>
        <RateInput rate={rate} setRate={setRate} />
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-widest text-[#6b7280] font-mono border-t border-[#d5dbde]">
            {["#", "Cliente", "Fatture", "Speso EUR", "Speso CHF", "Ultimo acquisto"].map((h) => <th key={h} className="px-4 py-2">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {shown.map((c) => <Row key={c.user_id} c={c} />)}
          {!rows.length && <tr><td colSpan={6} className="px-4 py-8 text-center text-[#6b7280] font-mono text-xs">Nessun cliente nel periodo</td></tr>}
        </tbody>
      </table>
      {rows.length > 10 && (
        <button data-testid="top-toggle-all" onClick={() => setAll(!all)}
          className="w-full border-t border-[#d5dbde] py-2.5 text-xs font-mono uppercase text-[#5b6168] hover:text-[#E0262C] hover:bg-[#f4f6f7] inline-flex items-center justify-center gap-1.5">
          {all ? <><ChevronUp className="w-3.5 h-3.5" /> Mostra solo Top 10</> : <><ChevronDown className="w-3.5 h-3.5" /> Mostra tutti ({rows.length})</>}
        </button>
      )}
    </div>
  );
};
